export default "__VITE_ASSET__D5RlMgwi__"